import React, { useEffect, useRef } from "react";
import { useDtrData } from "../../hooks/dtrData";
import { useQuery } from "@tanstack/react-query";
import axios from "../../api/axios";
import { destroySession } from "../../helpers/Session";
import { useNavigate } from "react-router-dom";

const DTRApproval = () => {
    const navigate = useNavigate();
    const { dtrData } = useDtrData();

    const timeoutRef = useRef(null);

    const accesstoken = sessionStorage.getItem('accesstoken');
    const uname = dtrData?.employee;
    const departmentslug = sessionStorage.getItem('departmentslug');

    const { data: approvals, isLoading: isLoadingApprovals, error: errorApprovals } = useQuery({
        queryKey: ['userTimesheetApprovals', { uname, departmentslug, dtrData }],
        queryFn: async () => {
            const res = await axios.get(`dtr/timesheets/approvals?uname=${uname}&department=${departmentslug}&payperiod=${dtrData?.payperiod}`, {
                headers: { 'Authorization': `Bearer ${accesstoken}` }
            });
            return res.data.response;
        },
        enabled: !!uname && !!departmentslug && !!dtrData?.payperiod
    });

    useEffect(() => {
        if (errorApprovals) {
            if (errorApprovals.response?.data.status === 'inactive') {
                destroySession();
                clearTimeout(timeoutRef.current);
                timeoutRef.current = setTimeout(() => { navigate('/error'); }, 1000);
            }
        }
    }, [errorApprovals]);

    return (
        <div className={`approvers ${isLoadingApprovals ? 'loading' : ''}`}>
            {isLoadingApprovals 
                ? (
                    [...Array(2)].map((_, i) => (
                        <div key={i} className="approver">
                            <p className="sequence">Approver {i + 1}</p>
                            <h3>Resty Alejo</h3>
                        </div>
                    ))
                ) : approvals?.length > 0 && approvals?.map((item, i) => (
                <div key={i} className={`approver ${item.status === 0 ? 'pending' : item.status === 1 ? 'approved' : item.status === 2 ? 'disapproved' : ''}`}>
                    <p className="sequence">Approver {i + 1}</p>
                    <h3>{item.name}</h3>
                    <p className={`status ${item.status === 0 ? 'pending' : item.status === 1 ? 'approved' : item.status === 2 ? 'disapproved' : ''}`}>
                        {item.status === 0 
                            ? 'Pending' 
                            : item.status === 1 
                                ? 'Approved'
                                : item.status === 2 
                                    ? 'Disapproved' 
                                    : ''
                        }
                    </p>
                </div>
            ))}
        </div>
    )
}

export default DTRApproval;